import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import styles from './BarChart.styles';
import { ResponsiveBar } from '@nivo/bar';

const chartOptions = {
  layout: 'vertical',
  indexBy: 'indexBy',
  groupMode: 'stacked',

  colors: ({ id, data }) => data[`${id}Color`],

  // labelTextColor: 'white',
  enableLabel: false,

  // SPACING
  padding: 0.3,
  margin: {
    top: 30,
    // right: 125,
    bottom: 80,
    left: 40,
  },

  // LABELS
  labelSkipHeight: 12,
  labelSkipWidth: 12,

  // AXISES
  axisTop: null,
  axisRight: null,
  axisBottom: {
    tickSize: 0,
    // tickPadding: 5,
    tickRotation: 45,
  },
  axisLeft: {
    tickSize: 0,

    // labelFormat: '.2s',
    // tickValues: [0, 25, 50, 100],
    // tickCount: 4,
    // format: v => 32,

    // tickPadding: 5,
    // tickRotation: 0,
    // legendPosition: 'middle',
    // legendOffset: -40,
  },

  // LEGENDS
  legends: [
    {
      dataFrom: 'keys',
      anchor: 'bottom',
      direction: 'row',
      justify: false,
      translateX: 0,
      translateY: 60,
      itemsSpacing: 2,
      itemWidth: 100,
      itemHeight: 20,
      itemDirection: 'top-to-bottom',
      itemOpacity: 0.85,
      symbolSize: 18,
      symbolShape: 'circle',
      effects: [
        {
          on: 'hover',
          style: {
            itemOpacity: 1,
          },
        },
      ],
    },
  ],

  // ANIMATION
  animate: true,
  motionStiffness: 90,
  motionDamping: 15,

  theme: {
    axis: {
      text: {
        fontSize: 16,
        fontWeight: 600,
      },
    },
  },
};

const BarChart = props => {
  const { classes, data, chartProps, ...rest } = props;

  return (
    <div
      style={{
        height: 'calc(30vh)',
        // border: '1px solid red',
      }}
    >
      <ResponsiveBar
        //
        {...chartOptions}
        {...chartProps}
        {...rest}
        data={data}
      />
    </div>
  );
};

BarChart.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(BarChart);
